import axios from "axios";

axios.defaults.withCredentials = true;

export default {
  async saveRIB(rib) {
    var dataFile = new FormData();
    dataFile.append("file", rib.nameFile, rib.nameFile.name);
    var exportRIBString = JSON.stringify(rib);
    var exportRIB = JSON.parse(exportRIBString);
    exportRIB.nameFile = rib.nameFile.name;
    dataFile.append("rib", JSON.stringify(exportRIB));
    const changementRIB = await axios.post(
      process.env.VUE_APP_BACKEND_API_URL + process.env.VUE_APP_URL_RIB,
      dataFile,
      {
        "content-type": "multipart/form-data",
      }
    );
    return changementRIB.data;
  },

  async getDemandesGestionnaire() {
    const demandes = await axios.get(
      process.env.VUE_APP_BACKEND_API_URL +
        process.env.VUE_APP_URL_RIB +
        "/drh/forGestionnaire"
    );
    return demandes.data;
  },

  async getDemandesGestionnaireByUid(uid) {
    const demandes = await axios.get(
      process.env.VUE_APP_BACKEND_API_URL +
        process.env.VUE_APP_URL_RIB +
        "/drh/forGestionnaire/" +
        uid
    );
    return demandes.data;
  },

  async getDemandeFileDRH(idFile) {
    return (
      process.env.VUE_APP_BACKEND_API_URL +
      process.env.VUE_APP_URL_FILE_RIB_DRH +
      idFile
    );
  },

  async getDemandeFileAgent(idFile) {
    return (
      process.env.VUE_APP_BACKEND_API_URL +
      process.env.VUE_APP_URL_FILE_RIB_AGENT +
      idFile
    );
  },

  async updateDemande(RIB) {
    return (
      await axios.put(
        process.env.VUE_APP_BACKEND_API_URL +
          process.env.VUE_APP_URL_RIB +
          "/drh",
        RIB,
        { "content-type": "application/json" }
      )
    ).data;
  },

  async getDemandes() {
    return (
      await axios.get(
        process.env.VUE_APP_BACKEND_API_URL + process.env.VUE_APP_URL_RIB
      )
    ).data;
  },
};
